import { vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77c807f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eg-img-container" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives(_createElementVNode("img", {
      src: _ctx.image,
      alt: _ctx.guest?.name,
      style: _normalizeStyle(_ctx.styles)
    }, null, 12, _hoisted_2), [
      [_vShow, !this.image.includes(undefined)]
    ]),
    _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
  ]))
}